import { WaConfigQueryResult } from '@graphqlTypes/sitecore';
import { withBasePath } from '@src/common/path-convert';
import { fetcher } from '@src/utils/fetcher';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';
export function useWAConfig(): WaConfigQueryResult | undefined {
    const router = useRouter();
    const url = useMemo(
        () => withBasePath(`/api/wa-config/?lang=${router.locale}`),
        [router.locale]
    );
    const { data } = useSWRImmutable<WaConfigQueryResult>(url, fetcher, {
        revalidateOnReconnect: true,
    });

    return data;
}
